// "Still building · open source" on the practice view. Two columns.

const OPEN_SOURCE = [
	{
		heading: "Frameworks",
		entries: [
			{
				title: "Rhubarb",
				description:
					"Document understanding with multi-modal LLMs, built ground-up. AWS Labs.",
				link: "https://awslabs.github.io/rhubarb/index.html#",
			},
			{
				title: "Textractor",
				description:
					"Python package working across four Amazon Textract APIs, including the layout linearizer.",
				link: "https://aws-samples.github.io/amazon-textract-textractor/index.html",
			},
			{
				title: "IDP CDK Constructs",
				description:
					"L3 constructs for deploying document processing workflows at scale.",
				link: "https://github.com/aws-samples/amazon-textract-idp-cdk-constructs",
			},
		],
	},
	{
		heading: "Reference implementations",
		entries: [
			{
				title: "IDP with AWS AI services",
				description:
					"The canonical walkthrough, extended with generative AI.",
				link: "https://github.com/aws-samples/aws-ai-intelligent-document-processing",
			},
			{
				title: "LLM safety and privacy",
				description:
					"Trust, safety and privacy patterns for generative applications.",
				link: "https://github.com/annjawn/llm-safety-privacy",
			},
			{
				title: "PHI de-identification",
				description:
					"De-identifying medical documents with Comprehend Medical and Textract.",
				link: "https://github.com/aws-samples/aws-ai-phi-deidentification",
			},
		],
	},
];

export { OPEN_SOURCE };
